import { ValidatorFn } from '@angular/forms';
import { DataTypes } from '../enums/DataType';
import { ControlBase } from './ControlBase';
import { TemplateRef } from '@angular/core';
export abstract class IControls extends ControlBase {
  DomID: string | undefined;
  Name!: string;
  DisplayName!: string;
  controlType?: string;
  colNumber!: number;
  rowNumber!: number;
  colSpanNumber?: number;
  DataType?: any;
  IsEditable?: boolean;
  IsFilterable?: boolean;
  IsNumber2Boolean?: Boolean;
  DefaultValue?: string | number | null | Date | boolean;
  viewCellStyle?: string;
  IsVisible?: boolean;
  Width?: number;
  Style?: string
  Mask?: string
  HyperLink?:string;
  lookupTemplate?: {
    Key: string | undefined;
    ID: string | undefined;
    Description?: string
    AfterLoad?: Function;
    BeforeLoad?: Function;
    OnClose?: Function;
    OnOpen?: Function;
    OnOpenSecondLkp?: Function;
    ReturnedValueEmitter?: Function;
    DataSource: any;
    hasSecondLkp?: boolean;
    route?: string,
    Title?: string,
    hasSelection?: boolean | undefined;
  };
  dropDownTemplate?: {
    value: string;
    text: string;
    list: any[];
    IsFilterable?:boolean; 
    SuggestedList?: any[];
    OnValueChange?: Function | undefined;
    OnselectionChange?: Function;
    OnOpen?:Function;
    OnFocus?:Function;
  }
  ActionButton?: {
    Action: Function
  }
  Validators?: ValidatorFn | null | Array<ValidatorFn>;
  TextAfterInput?: string;
  colorPickerSettings?: {
    required: boolean,
    clearButton?: boolean,
  };
  datePickerSettings?: {
    dateFormat: string;
  };
  TemplateRef?: TemplateRef<any>;
  Precision?:number;
  LogImageTemplate?: {
    filterList: any[];
  }
}
